/**
 * Cabecera de una vista del backoffice: titulo, bajada y acciones.
 *
 * El titulo es el `<h1>` de la pagina: cada vista del backoffice es una pagina
 * distinta y tiene que decir cual es.
 */
import type { ReactNode } from 'react';

export interface BarraAdminProps {
  titulo: string;
  bajada?: string;
  acciones?: ReactNode;
}

export function BarraAdmin({ titulo, bajada, acciones }: BarraAdminProps) {
  return (
    <header className="admin-barra">
      <div>
        <h1>{titulo}</h1>
        {bajada !== undefined ? <p className="sub">{bajada}</p> : null}
      </div>
      {acciones !== undefined ? <div className="admin-acciones">{acciones}</div> : null}
    </header>
  );
}
